const ACCEPTED_FILE_TYPES = ["image/jpg", "image/jpeg", "image/png"];
const ACCEPTED_FILE_SIZE = 10485760; // files are bytes: 10(mb) * 1024 * 1024 = 10485760
export default function useFileInputValidations() {
  const isFileTypeAllowed = (file) => {
    return !ACCEPTED_FILE_TYPES.includes(file.type)
      ? "Please upload a JPG, JPEG, or PNG type file"
      : "";
  };
  const isSingleFileSizeInLimits = (file) => {
    return file.size > ACCEPTED_FILE_SIZE
      ? "Your uploaded document's size should be less than 10 MB"
      : "";
  };

  const areMultiFileSizesInLimits = (files) => {
    const totalFileSizes = Object.keys(files).reduce(
      (acc, file) => files[file].size + acc,
      0
    );
    return totalFileSizes > ACCEPTED_FILE_SIZE
      ? "Your total uploaded document's size should be less than 10 MB"
      : "";
  };

  const areMultiFileTypesAllowed = (files) => {
    const fileTypeAllowed = (fileType) =>
      ACCEPTED_FILE_TYPES.includes(fileType.type);
    const fileTypeNotAllowed = !Object.values(files).every(fileTypeAllowed);

    return fileTypeNotAllowed
      ? "Please upload your documents as JPG, JPEG, or PNG type file"
      : "";
  };

  return {
    isFileTypeAllowed,
    isSingleFileSizeInLimits,
    areMultiFileSizesInLimits,
    areMultiFileTypesAllowed,
    ACCEPTED_FILE_TYPES,
  };
}
